import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import HighlightPanel, { HighlightPanelSize } from '@helsenorge/designsystem-react/components/HighlightPanel';
import Title from '@helsenorge/designsystem-react/components/Title';
import PortableText from '../richtext';
const FaktaBlock = ({ title, titleHtmlMarkup, introduction, text, icon, color }) => {
    return (_jsxs(HighlightPanel, { color: color, svgIcon: icon, size: HighlightPanelSize.fluid, children: [title && (_jsx(_Fragment, { children: _jsx(Title, { htmlMarkup: titleHtmlMarkup, appearance: "title4", children: title }) })), introduction && _jsx("p", { children: introduction }), text && _jsx(PortableText, { value: text })] }));
};
export default FaktaBlock;
